<template>
  <div>
    <p class="text-h6 text-md-h4 text-center pt-4">Мы понимаем что вас беспокоит</p>
    <v-container class="pa-4 text-center">
      <v-row class="fill-height" align="center" justify="center">
        <template v-for="(item, i) in items">
          <v-col :key="i" cols="12" md="4" class="slide-up">
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 12 : 2"
                :class="{ 'on-hover': hover }"
                :color="item.color"
              >
                <v-card-title class="text-h6 white--text">
                  <v-row
                    class="fill-height flex-column"
                    justify="space-between"
                  >
                    <span class="mt-4 subheading text-center problem">
                      {{ item.title }}
                    </span>

                    <div>
                      <p
                        class="
                          text-caption
                          font-weight-medium font-italic
                          text-center
                        "
                      >
                        {{ item.subtext }}
                      </p>
                    </div>
                  </v-row>
                </v-card-title>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  data: () => ({
    items: [
      {
        title: "Как определиться с профессией?",
        subtext: "Где учиться после шклолы?",
        color: "main",
      },
      {
        title: "У вашего ребёнка мало друзей?",
        subtext: "Круг общения ребенка вам не нравится",
        color: "alert",
      },
      {
        title: "Ребёнок тратит время впустую?",
        subtext: "Игры, тусовки, праздное шатание",
        color: "third",
      },
    ],
  }),
  mounted() {
    gsap.from(".slide-up", {
      scrollTrigger: {
        trigger: ".slide-up",
        start: "top bottom-=200px",
        once: true,
        toggleActions: "restart pause resume pause",
      },
      y: 30,
      duration: 2,
    });
  },
};
</script>


<style lang="scss" scoped>
.problem{
 word-break: keep-all;
}
</style>